// src/services/documentService.js
import { apiService } from './api.js';

export const documentService = {
    // Subir documento
    async uploadDocument(formData) {
        return await apiService.upload('/documents/upload', formData);
    },

    // Obtener todos los documentos del usuario
    async getDocuments() {
        return await apiService.request('/documents');
    },

    // Obtener detalles de un documento
    async getDocumentDetails(documentId) {
        return await apiService.request(`/documents/${documentId}/details`);
    },

    // Regenerar link de firma
    async regenerateLink(documentId, expiresInHours = 72) {
        return await apiService.request(`/documents/${documentId}/regenerate-link`, {
            method: 'POST',
            body: JSON.stringify({ expiresInHours }),
        });
    },

    // 🔓 Descargar documento original (PÚBLICO - sin autenticación)
    async downloadOriginal(documentId, originalName) {
        try {
            const response = await fetch(`${apiService.baseURL}/documents/${documentId}/download/original`);

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Error al descargar el documento' }));
                throw new Error(errorData.error || 'Error al descargar el documento');
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = downloadUrl;
            a.download = originalName || 'documento.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);

            return true;
        } catch (error) {
          //  console.error('Error en downloadOriginal:', error);
            throw error;
        }
    },

    async downloadSigned(documentId, originalName) {
        try {
            const response = await fetch(`${apiService.baseURL}/documents/${documentId}/download/signed`);

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ error: 'Error al descargar el documento firmado' }));
                throw new Error(errorData.error || 'Error al descargar el documento firmado');
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = downloadUrl;
            a.download = `firmado-${originalName || 'documento'}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(a);

            return true;
        } catch (error) {
           // console.error('Error en downloadSigned:', error);
            throw error;
        }
    },

    // Obtener información de documento para firma (público)
    async getDocumentForSigning(token) {
        const response = await fetch(`${apiService.baseURL}/documents/${token}`);

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al obtener el documento');
        }

        return await response.json();
    },

    // Firmar documento (público)
    async signDocument(token, signatureData) {
        const response = await fetch(`${apiService.baseURL}/documents/${token}/sign`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(signatureData),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al firmar el documento');
        }

        return await response.json();
    },

    // Verificar documento (público)
// Verificar documento (público)
async verifyDocument(token) {
    return await apiService.publicRequest(`/verification/${token}`);
},

// Obtener historial de verificaciones (público)
async getVerificationHistory(token) {
    return await apiService.publicRequest(`/verification/${token}/history`);
},

    // Obtener historial de verificaciones (público)
/*     async getVerificationHistory(token) {
        const response = await fetch(`${apiService.baseURL}/documents/${token}/verification-history`);

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.error || 'Error al obtener el historial');
        }

        return await response.json();
    }, */
};